import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';
import Modal from "../../component/Modal";
import Chat from "../../component/Chat";

const MemberDetail = () => {
	const navigate = useNavigate();
	const { user_seq } = useParams();

	const [userInfo, setUserInfo] = useState({
		"2nd_certi_YN": "",
		"2nd_certi_ty": "",
		"agree_ads": "",
		"agree_privacy_policy": "",
		"agree_terms": "",
		"agree_third_party_sharing": "",
		"chat_online_YN": null,
		"chat_room_no": null,
		"fail_cnt": 0,
		"join_ty": "",
		"last_login_dt": "",
		"last_login_ip": "",
		"login_cnt": 0,
		"reg_dtm": "",
		"user_email": "",
		"user_id": "",
		"user_phone": "",
		"user_pwd": "",
		"user_seq": 0,
		"user_stat": "",
		"user_ty": "",
		// 추가정보
		"user_corp": "",
		"user_corp_phone": "",
		"user_corp_no": "",
		"user_corp_director": "",
		"user_payment_card_seq": "",
		"user_payment_bank_no": "",
		"user_payment_bank_name": "",
		"user_payment_bank_cd": "",
	});
	const [paymentList, setPaymentList] = useState([]);
	const [pointChange, setPointChange] = useState(false);
	const [chattingView, setChattingView] = useState(false);

	// 추가정보
	const [bankList, setBankList] = useState([]);
	const [selectedBankCode, setSelectedBankCode] = useState('');

	const fetchUserData = useCallback(async () => {
		try {
			const successHandler = (response) => {
				console.log('response', response.data)
				if (response.messageCode === 200) {
					const data = response.data || {};
					setUserInfo((prevUserInfo) => ({
						...prevUserInfo,
						...Object.keys(prevUserInfo).reduce((acc, key) => {
							acc[key] = data[key] || "";
							return acc;
						}, {})
					}));
					setSelectedBankCode(data.user_payment_bank_cd)
				} else {
					toast.error("회원 정보를 불러올 수 없습니다.");
				}
			};

			const errorHandler = (error) => {
				toast.error("회원 정보를 불러오는 중 오류가 발생했습니다.");
			};

			await request.get(`/user/info-with-detail/${user_seq}`, {}, successHandler, errorHandler);
		} catch (error) {
			toast.error("회원 정보를 불러오는 중 오류가 발생했습니다.");
		}
	}, [user_seq]);

	// Fetch payment data
	const fetchPaymentData = useCallback(async () => {
		try {
			const successHandler = (response) => {
				if (response.messageCode === 200) {
					setPaymentList(response.data.dataList);
				} else {
					toast.error("결제 정보를 불러올 수 없습니다.");
				}
			};

			const errorHandler = (error) => {
				toast.error("결제 정보를 불러오는 중 오류가 발생했습니다.");
			};

			await request.get(`/payments/all/list`, { user_seq }, successHandler, errorHandler);
		} catch (error) {
			toast.error("결제 정보를 불러오는 중 오류가 발생했습니다.");
		}
	}, [user_seq]);

	const getBankInfo = useCallback(() => {
		let params = {};

		const successHandler = (response) => {
			if (response.messageCode === 200) {
				setBankList(response.data.data_list);
			} else {
				console.log('은행 정보를 불러올수없습니다.');
				toast.error('은행 정보를 불러올수없습니다.');
			}
		};
		const failHandler = (error) => {
			console.log(error);
		};

		request.get('/common/code/bank_cd', params, successHandler, failHandler);
	}, []);

	useEffect(() => {
		getBankInfo();
		fetchUserData();
		fetchPaymentData();
	}, [getBankInfo, fetchUserData, fetchPaymentData]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setUserInfo((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async () => {
		try {
			const successHandler = (response) => {
				console.log(response)
				if (response.messageCode === 200) {
					toast.success("회원 정보가 성공적으로 수정되었습니다.");
					// navigate("/Member/MemberManage");
				} else if (response.messageCode === 411) {
					toast.error("변경사항이 없습니다");
				}
			};

			const errorHandler = (error) => {
				toast.error("회원 정보 수정 중 오류가 발생했습니다.");
			};

			await request.put(`/user/info-with-detail/${user_seq}`, userInfo, successHandler, errorHandler);
		} catch (error) {
			toast.error("회원 정보 수정 중 오류가 발생했습니다.");
		}
	};

	// 은행선택
	const handleBankChange = (event) => {
		setSelectedBankCode(event.target.value);
		setUserInfo((prev) => ({ ...prev, user_payment_bank_cd: event.target.value }));
	};


	return (
		<main>
			<h2 className="adm_com_pg_tit">회원 관리</h2>
			<h3 className="adm_com_pg_tit__wrap margin_top">- 회원기본정보
				<div className="adm_com_btn_wrap right">
					<button className="adm_com_btn gray s" onClick={handleSubmit}>수정</button>
					<button onClick={() => navigate("/Member/MemberManage")} className="adm_com_btn blue s">목록</button>
				</div>
			</h3>
			<table className='adm_com_board_list type_row'>
				<colgroup>
					<col width="10%" /><col width="40%" />
					<col width="10%" /><col width="40%" />
				</colgroup>
				<tbody>
					<tr>
						<th>아이디</th>
						<td colSpan="3">{userInfo.user_id}</td>
					</tr>
					<tr>
						<th>휴대폰</th>
						<td colSpan="3">
							<input type="text" className="input wl" name="user_phone" value={userInfo.user_phone} onChange={handleChange} />
						</td>
					</tr>
					<tr>
						<th>최근접속일</th>
						<td>{userInfo.last_login_dt}</td>
						<th>가입일자</th>
						<td>{userInfo.reg_dtm}</td>
					</tr>
				</tbody>
			</table>
			<h3 className="adm_com_pg_tit__wrap margin_top">- 회원추가정보
			</h3>
			<table className='adm_com_board_list type_row'>
				<colgroup>
					<col width="10%" /><col width="40%" />
					<col width="10%" /><col width="40%" />
				</colgroup>
				<tbody>
					<tr>
						<th>회사명</th>
						<td>
							<input type="text" className="input wl" name="user_corp" value={userInfo.user_corp} onChange={handleChange} />
						</td>
						<th>대표자명</th>
						<td><input type="text" className="input wl" name="user_corp_director" value={userInfo.user_corp_director} onChange={handleChange} /></td>
					</tr>
					<tr>
						<th>회사연락처</th>
						<td colSpan="3">
							<input type="text" className="input wl" name="user_corp_phone" value={userInfo.user_corp_phone} onChange={handleChange} />
						</td>
					</tr>
					<tr>
						<th>사업자번호</th>
						<td colSpan="3"><input type="text" className="input wl" name="user_corp_no" value={userInfo.user_corp_no} onChange={handleChange} /></td>
					</tr>
					<tr>
						<th>계좌</th>
						<td colSpan="3">
							<select
								className="select ws"
								value={selectedBankCode}
								onChange={handleBankChange}
							>
								<option>은행선택</option>
								{bankList.map((bank) => (
									<option key={bank.comm_code} value={bank.comm_code}>
										{bank.code_nm}
									</option>
								))}
							</select>
							<input
								type="text"
								className="input wl"
								placeholder="예금주 입력"
								name="user_payment_bank_name"
								value={userInfo.user_payment_bank_name}
								onChange={handleChange}
							/>
							<input
								type="text"
								className="input wl"
								placeholder="계좌번호 입력"
								name="user_payment_bank_no"
								value={userInfo.user_payment_bank_no}
								onChange={handleChange}
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<h3 className="adm_com_pg_tit__wrap margin_top">- 사용중인 서비스</h3>
			<table className='adm_com_board_list'>
				<colgroup>
					<col width="5%" /><col width="10%" /><col width="10%" /><col width="10%" /><col width="10%" /><col width="10%" />
				</colgroup>
				<thead>
					<tr>
						<th>번호</th>
						<th>서비스 명</th>
						<th>서비스 기간</th>
						<th>결제 방법</th>
						<th>사용금액</th>
						<th>환불금액</th>
						<th>결제금액</th>
						<th>포인트</th>
						<th>쿠폰</th>
						<th>실 결제금액</th>
					</tr>
				</thead>
				<tbody>
					{paymentList && paymentList.map((item, idx) => (
						<tr key={item.goods_seq}>
							<td>{idx + 1}</td>
							<td>{item.goods_seq}</td>
							<td>-</td>
							<td>{item.pay_method}</td>
							<td>0</td>
							<td>0</td>
							<td>{item.request_amt}</td>
							<td>0</td>
							<td>0</td>
							<td>0</td>
						</tr>
					))}
				</tbody>
			</table>
			<Modal open={pointChange} close={() => setPointChange(false)} popSize="m">
				<div className="pop_tit">포인트 변동하기</div>
				<div className="content_container">
					<table className='adm_com_board_list type_row'>
						<colgroup>
							<col width="20%" /><col />
						</colgroup>
						<tbody>
							<tr>
								<th>종류</th>
								<td>
									<div className="adm_com_input_wrap">
										<input type="checkbox" className="adm_com_chk circle" id="point01" name="chk_point" value="Y" />
										<label htmlFor="point01">충전</label>
										<input type="checkbox" className="adm_com_chk circle" id="point02" name="chk_point" value="Y" />
										<label htmlFor="point02">차감</label>
									</div>
								</td>
							</tr>
							<tr>
								<th>금액</th>
								<td><input type="text" className="input" defaultValue={'30,000'} /></td>
							</tr>
							<tr>
								<th>변동내용</th>
								<td>
									<textarea className="textarea">포인트 환불</textarea>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="btn_container">
					<button className="adm_com_btn blue">확인</button>
					<button onClick={() => setPointChange(false)} className="adm_com_btn gray">취소</button>
				</div>
			</Modal>
			<Modal open={chattingView} close={() => setChattingView(false)} popSize="m">
				<Chat />
				<div className="btn_container">
					<button onClick={() => setChattingView(false)} className="adm_com_btn s gray">닫기</button>
				</div>
			</Modal>
			<ToastContainer />
		</main>
	);
};

export default MemberDetail;
